module.exports = __webpack_public_path__ + "entry_configuration-0fd125b3e0cb8baa16fa66a9d6329d18.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/entry_configuration.png
// module id = D5fg
// module chunks = client